<template>
  <section v-if="user">
    <v-container>
      
      <!-- <div
          style="
          position: fixed;
    right: 10%;
    bottom:10%;
    z-index: 555;
    cursor: pointer;
          "
        >
          <a :href="`tel:+${user.phone}`" class="text-black iconssocials"
        >
            <v-icon icon="mdi-phone" class="mx-1"></v-icon
          ></a>
  
          <v-icon icon="mdi-forum-outline" class="iconssocials" @click="navigateTo('/chats')"></v-icon>
          <a
            :href="`https://api.whatsapp.com/send?phone=${user.whatsapp}`"
            target="_blank"
            class="text-black iconssocials"
          >
            <v-icon icon="mdi-whatsapp" class="mx-1"></v-icon>
          </a>
          <v-icon
            icon="mdi-block-helper"
            @click="dialog = true"
            class=" iconssocials"
          ></v-icon>
        </div> -->
      <v-dialog v-model="dialog" width="500">
        <v-card class="text-center py-5">
          <img :src="warning" width="100" class="mx-auto" alt="" />
          <h3>
            {{ $t("Do_block_advertiser") }}
          </h3>
          <div class="d-flex justify-center align-center mt-2">
            <button
              @click="blocked(user.id)"
              class="previewads pa-1 mx-1 rounded"
              style="width: 100px"
            >
              {{ $t("yes") }}
            </button>
            <button
              @click="dialog = false"
              class="border rounded text-black pa-1 mx-1"
              style="width: 100px"
            >
              {{ $t("no") }}
            </button>
          </div>
        </v-card>
      </v-dialog>

      <div class="page-header">
        <h1 class="page-title">{{ $t("Preview_ad") }}</h1>
      </div>
      
      <v-card class="ad-detail-card" elevation="2">
        <!-- Image Gallery Section -->
        <div class="image-gallery-section">
          <vue-picture-swipe :items="itemsimage" v-if="itemsimage.length > 0"></vue-picture-swipe>
          <div v-else class="no-image-placeholder">
            <v-icon icon="mdi-image-off" size="64" color="grey-lighten-1"></v-icon>
            <p class="text-grey">لا توجد صور متاحة</p>
          </div>
        </div>

        <!-- Property Type Badge -->
        <div class="property-badge-wrapper">
          <v-chip class="property-type-badge" color="yellow-darken-1" size="large">
            <v-icon start icon="mdi-tag"></v-icon>
            {{ addetail.estate_type }} {{ addetail.ad_type }}
          </v-chip>
        </div>

        <!-- Price and Basic Info Section -->
        <div class="price-info-section">
          <div class="price-section">
            <h2 class="property-price">
              {{ addetail?.price?.split('.')[0] }}
              <span class="currency">{{ $t("SR") }}</span>
            </h2>
            <div class="property-type-text">
              <v-icon icon="mdi-home-variant" size="18" class="mr-1"></v-icon>
              {{ addetail.estate_type }} {{ addetail.ad_type }}
            </div>
            <div class="location-info">
              <v-icon icon="mdi-map-marker-outline" size="20" color="primary"></v-icon>
              <span>{{ addetail.city }}</span>
            </div>
          </div>
          <div class="date-section">
            <v-icon icon="mdi-calendar-outline" size="20" color="grey-darken-1"></v-icon>
            <span class="publish-date">{{ addetail.publish_date }}</span>
          </div>
        </div>
        <!-- Properties/Features Section -->
        <div class="properties-section" v-if="addetail.properties && addetail.properties.length > 0">
          <h3 class="section-title">
            <v-icon icon="mdi-star-circle" class="mr-2"></v-icon>
            {{ $t("Public_services") }}
          </h3>
          <div class="properties-grid">
            <div
              class="property-card"
              v-for="(prop, i) in addetail.properties"
              :key="i"
            >
              <div class="property-icon-wrapper">
                <img :src="prop.image" class="property-icon" :alt="prop.name" />
              </div>
              <div class="property-content">
                <p class="property-name">{{ prop.name }}</p>
                <div class="property-values">
                  <span 
                    v-for="(ele, idx) in prop.values" 
                    :key="idx"
                    class="property-value"
                  >
                    {{
                      typeof ele === 'object'
                        ? (ele[0] === "true" ? "نعم" : ele[0] === "false" ? "لا" : ele[0])
                        : ele
                    }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- Details Section -->
        <div class="details-section">
          <div class="details-column">
            <h3 class="section-title">
              <v-icon icon="mdi-information" class="mr-2"></v-icon>
              {{ $t("Ad_Details") }}
            </h3>
            <div class="detail-item">
              <label class="detail-label">
                <v-icon icon="mdi-calendar-remove" size="18" class="mr-1"></v-icon>
                {{ $t("Expiry_date") }}:
              </label>
              <span class="detail-value">{{ addetail.end_date || 'غير محدد' }}</span>
            </div>
            <div class="detail-item">
              <label class="detail-label">
                <v-icon icon="mdi-eye" size="18" class="mr-1"></v-icon>
                {{ $t("View") }}:
              </label>
              <span class="detail-value">{{ addetail.visits_count || 0 }}</span>
            </div>
            <div class="detail-item" v-if="addetail.delegation_number">
              <label class="detail-label">
                <v-icon icon="mdi-certificate" size="18" class="mr-1"></v-icon>
                {{ $t("Val_number") }}:
              </label>
              <span class="detail-value">{{ addetail.delegation_number }}</span>
            </div>
            <div class="detail-item" v-if="addetail.advertiser_registration_number">
              <label class="detail-label">
                <v-icon icon="mdi-file-document" size="18" class="mr-1"></v-icon>
                {{ $t("Advertising_number") }}:
              </label>
              <span class="detail-value">{{ addetail.advertiser_registration_number }}</span>
            </div>
          </div>
          
          <div class="details-column">
            <h3 class="section-title">
              <v-icon icon="mdi-map-marker" class="mr-2"></v-icon>
              {{ $t("Location_Details") }}
            </h3>
            <div class="detail-item">
              <label class="detail-label">
                <v-icon icon="mdi-ruler-square" size="18" class="mr-1"></v-icon>
                {{ $t("Area") }}:
              </label>
              <span class="detail-value">{{ addetail.estate_area || 'غير محدد' }}</span>
            </div>
            <div class="detail-item">
              <label class="detail-label">
                <v-icon icon="mdi-city" size="18" class="mr-1"></v-icon>
                {{ $t("City") }}:
              </label>
              <span class="detail-value">{{ addetail.city }}</span>
            </div>
            <div class="detail-item" v-if="addetail.neighborhood">
              <label class="detail-label">
                <v-icon icon="mdi-map" size="18" class="mr-1"></v-icon>
                {{ $t("neighborhood") }}:
              </label>
              <span class="detail-value">{{ addetail.neighborhood }}</span>
            </div>
            <button
              @click="gotomap(addetail.lat, addetail.lng)"
              class="map-button"
              v-if="addetail.lat && addetail.lng"
            >
              <v-icon icon="mdi-map" class="mr-2"></v-icon>
              {{ $t("Show_themap") }}
            </button>
          </div>
        </div>
        
        <!-- Services Section -->
        <div class="services-section" v-if="serv && serv.length > 0">
          <h2 class="services-title">
            <v-icon icon="mdi-tools" class="mr-2"></v-icon>
            {{ $t("Public_services") }}
          </h2>
          <div class="services-grid">
            <div
              v-for="(item, i) in serv"
              :key="i"
              @click="providers(item.id)"
              class="service-card"
            >
              <div class="service-image-wrapper">
                <img :src="item.image" class="service-image" :alt="item.name" />
              </div>
              <p class="service-name">{{ item.name }}</p>
            </div>
          </div>
        </div>
      </v-card>
    </v-container>
    <v-container>
      <v-card class="advertiser-card" elevation="2">
        <h2 class="advertiser-title">
          <v-icon icon="mdi-account-circle" class="mr-2"></v-icon>
          {{ $t("Advertiser_data") }}
        </h2>
        <div class="advertiser-content">
          <div class="advertiser-avatar-section">
            <div class="avatar-wrapper">
              <img 
                v-if="user.image" 
                :src="user.image" 
                class="advertiser-avatar" 
                :alt="user.name"
              />
              <v-icon 
                v-else 
                icon="mdi-account-circle" 
                size="80" 
                color="grey-lighten-1"
                class="advertiser-avatar-placeholder"
              ></v-icon>
              <v-icon
                v-if="user.is_nafath_verified"
                icon="mdi-check-decagram"
                class="verified-badge"
                color="primary"
              ></v-icon>
            </div>
            <h3 class="advertiser-name">
              {{ user.name }}
            </h3>
          </div>
          
          <div class="advertiser-actions">
            <a 
              :href="`tel:+${user.phone}`" 
              class="action-button phone-button"
              v-if="user.phone"
            >
              <v-icon icon="mdi-phone" size="20"></v-icon>
              <span>اتصل</span>
            </a>
            <button 
              class="action-button chat-button"
              @click="navigateTo('/chats')"
            >
              <v-icon icon="mdi-forum-outline" size="20"></v-icon>
              <span>محادثة</span>
            </button>
            <a
              :href="`https://api.whatsapp.com/send?phone=${user.whatsapp}`"
              target="_blank"
              class="action-button whatsapp-button"
              v-if="user.whatsapp"
            >
              <v-icon icon="mdi-whatsapp" size="20"></v-icon>
              <span>واتساب</span>
            </a>
            <button
              class="action-button block-button"
              @click="dialog = true"
            >
              <v-icon icon="mdi-block-helper" size="20"></v-icon>
              <span>حظر</span>
            </button>
          </div>
        </div>
      </v-card>
    </v-container>
  </section>
  <v-container v-else>
    <v-row>
      <v-col cols="12" v-for="text in texts" :key="text">
        <v-skeleton-loader
          class="mx-auto border-0"
          type="paragraph"
        ></v-skeleton-loader>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import VuePictureSwipe from 'vue-picture-swipe';

import imgwarn from "../../assets/icon/warning.png";
import crudDataService from "@/Services/crudDataService";
export default {
  components: {
    VuePictureSwipe
  },
  data() {
    return {
      dialog: false,
      addetail: "",
      items: [],
      serv: [],
      user: "",
      warning: imgwarn,
      texts: [1, 2, 3, 4, 5],
      alert: false,
      itemsimage: [
        
      ]
    
    };
  },
  methods: {
    navigateTo(route) {
      this.$router.push(route);
    },
    async blocked(id) {
      await crudDataService.get(`user-block`, id).then((res) => {
        this.dialog = false;
        this.$swal.fire({
          title: res.data.message,
          position: "top-start",
          showCancelButton: false,
          showConfirmButton: false,
          timer: 1500,
          icon: "success",
          customClass: {
            icon: "my-custom-class",
            title: "swal2-title", // Define your custom class here
          },
        });
      });
    },
    providers(id) {
      this.$router.push({ name: "provider", params: { id } });
    },
    async service() {
      let response = await crudDataService.getAll(`services`);
      this.serv = response.data.data;
    },
    gotomap(lang, lat) {
      this.$router.push({
        name: "MapAd",
        params: { param1: `${lang}`, param2: `${lat}` },
      });
    },
    async Singlead() {
      let response = await crudDataService.get(
        `show-ad`,
        `${this.$route.params.id}`
      );
      this.addetail = response.data.data.ad;
      response.data.data.ad.attachment.forEach(element => {
        this.itemsimage.push({
        src: element,
          thumbnail: element,
          w: 300,
          h: 300
         
      })

      });
     
      this.user = response.data.data.ad.user;
      console.log(this.user);
    },
  },
  mounted() {
    this.service();
    this.Singlead();
  },
};
</script>
<style lang="scss" scoped>
.page-header {
  text-align: center;
  margin-bottom: 32px;
  padding: 24px 0;
  
  .page-title {
    font-size: 32px;
    font-weight: 700;
    color: #1f2937;
    margin: 0;
  }
}

.ad-detail-card {
  border-radius: 16px;
  overflow: hidden;
  margin-bottom: 32px;
  padding: 24px;
}

.image-gallery-section {
  margin-bottom: 24px;
  border-radius: 12px;
  overflow: hidden;
  
  .no-image-placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    height: 400px;
    background: #f3f4f6;
    border-radius: 12px;
    
    p {
      margin-top: 16px;
      font-size: 18px;
    }
  }
}

.property-badge-wrapper {
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
  
  .property-type-badge {
    font-size: 16px;
    font-weight: 600;
    padding: 8px 20px;
  }
}

.price-info-section {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 24px;
  background: linear-gradient(135deg, #f9fafb 0%, #ffffff 100%);
  border-radius: 12px;
  margin-bottom: 32px;
  border: 1px solid #e5e7eb;
  
  .price-section {
    flex: 1;
    
    .property-price {
      font-size: 36px;
      font-weight: 700;
      color: #1f2937;
      margin: 0 0 12px 0;
      
      .currency {
        font-size: 24px;
        font-weight: 500;
        color: #6b7280;
        margin-right: 8px;
      }
    }
    
    .property-type-text {
      display: flex;
      align-items: center;
      font-size: 18px;
      color: #4b5563;
      margin-bottom: 12px;
      font-weight: 500;
    }
    
    .location-info {
      display: flex;
      align-items: center;
      gap: 8px;
      font-size: 16px;
      color: #6b7280;
    }
  }
  
  .date-section {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 20px;
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    
    .publish-date {
      font-size: 16px;
      color: #4b5563;
      font-weight: 500;
    }
  }
}

.properties-section {
  margin-bottom: 32px;
  
  .section-title {
    font-size: 24px;
    font-weight: 700;
    color: #1f2937;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
  }
  
  .properties-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
    gap: 16px;
    
    .property-card {
      background: white;
      border: 2px solid #e5e7eb;
      border-radius: 12px;
      padding: 16px;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      transition: all 0.3s ease;
      
      &:hover {
        border-color: #fede2c;
        transform: translateY(-4px);
        box-shadow: 0 4px 12px rgba(254, 222, 44, 0.2);
      }
      
      .property-icon-wrapper {
        margin-bottom: 12px;
        
        .property-icon {
          width: 40px;
          height: 40px;
          object-fit: contain;
        }
      }
      
      .property-content {
        width: 100%;
        
        .property-name {
          font-size: 14px;
          font-weight: 600;
          color: #1f2937;
          margin: 0 0 8px 0;
        }
        
        .property-values {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          gap: 4px;
          
          .property-value {
            font-size: 13px;
            color: #4b5563;
            font-weight: 500;
          }
        }
      }
    }
  }
}

.details-section {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 32px;
  margin-bottom: 32px;
  
  .details-column {
    background: #f9fafb;
    padding: 24px;
    border-radius: 12px;
    border: 1px solid #e5e7eb;
    
    .section-title {
      font-size: 20px;
      font-weight: 700;
      color: #1f2937;
      margin-bottom: 20px;
      display: flex;
      align-items: center;
      padding-bottom: 12px;
      border-bottom: 2px solid #e5e7eb;
    }
    
    .detail-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 12px 0;
      border-bottom: 1px solid #e5e7eb;
      
      &:last-child {
        border-bottom: none;
      }
      
      .detail-label {
        display: flex;
        align-items: center;
        font-size: 15px;
        font-weight: 600;
        color: #4b5563;
      }
      
      .detail-value {
        font-size: 15px;
        color: #1f2937;
        font-weight: 500;
      }
    }
    
    .map-button {
      margin-top: 16px;
      padding: 12px 24px;
      background: linear-gradient(135deg, #fede2c 0%, #f6c712 100%);
      color: #1f2937;
      border: none;
      border-radius: 8px;
      font-size: 16px;
      font-weight: 600;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.3s ease;
      width: 100%;
      
      &:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(254, 222, 44, 0.4);
      }
    }
  }
}

.services-section {
  margin-top: 32px;
  padding: 24px;
  background: #f9fafb;
  border-radius: 12px;
  
  .services-title {
    font-size: 24px;
    font-weight: 700;
    color: #1f2937;
    margin-bottom: 24px;
    display: flex;
    align-items: center;
  }
  
  .services-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    gap: 20px;
    
    .service-card {
      background: white;
      border-radius: 12px;
      padding: 20px;
      text-align: center;
      cursor: pointer;
      transition: all 0.3s ease;
      border: 2px solid transparent;
      
      &:hover {
        border-color: #fede2c;
        transform: translateY(-4px);
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      }
      
      .service-image-wrapper {
        margin-bottom: 12px;
        
        .service-image {
          width: 70px;
          height: 70px;
          object-fit: contain;
        }
      }
      
      .service-name {
        font-size: 16px;
        font-weight: 600;
        color: #1f2937;
        margin: 0;
      }
    }
  }
}

.advertiser-card {
  border-radius: 16px;
  padding: 32px;
  margin-top: 32px;
  
  .advertiser-title {
    font-size: 24px;
    font-weight: 700;
    color: #1f2937;
    margin-bottom: 24px;
    display: flex;
    align-items: center;
  }
  
  .advertiser-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    
    @media (min-width: 768px) {
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }
  }
  
  .advertiser-avatar-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    
    .avatar-wrapper {
      position: relative;
      
      .advertiser-avatar {
        width: 100px;
        height: 100px;
        border-radius: 50%;
        object-fit: cover;
        border: 4px solid #fede2c;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
      }
      
      .advertiser-avatar-placeholder {
        border-radius: 50%;
      }
      
      .verified-badge {
        position: absolute;
        bottom: 0;
        right: 0;
        background: white;
        border-radius: 50%;
        padding: 4px;
      }
    }
    
    .advertiser-name {
      font-size: 24px;
      font-weight: 700;
      color: #1f2937;
      margin: 0;
      display: flex;
      align-items: center;
      gap: 8px;
    }
  }
  
  .advertiser-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    justify-content: center;
    
    @media (min-width: 768px) {
      justify-content: flex-end;
    }
    
    .action-button {
      display: flex;
      align-items: center;
      gap: 8px;
      padding: 12px 20px;
      border-radius: 10px;
      font-size: 15px;
      font-weight: 600;
      text-decoration: none;
      transition: all 0.3s ease;
      border: 2px solid transparent;
      cursor: pointer;
      
      &.phone-button {
        background: linear-gradient(135deg, #10b981 0%, #059669 100%);
        color: white;
        
        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(16, 185, 129, 0.4);
        }
      }
      
      &.chat-button {
        background: linear-gradient(135deg, #0074c7 0%, #005a9e 100%);
        color: white;
        
        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(0, 116, 199, 0.4);
        }
      }
      
      &.whatsapp-button {
        background: linear-gradient(135deg, #25d366 0%, #128c7e 100%);
        color: white;
        
        &:hover {
          transform: translateY(-2px);
          box-shadow: 0 4px 12px rgba(37, 211, 102, 0.4);
        }
      }
      
      &.block-button {
        background: white;
        color: #ef4444;
        border-color: #ef4444;
        
        &:hover {
          background: #ef4444;
          color: white;
          transform: translateY(-2px);
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .price-info-section {
    flex-direction: column;
    gap: 16px;
    
    .price-section .property-price {
      font-size: 28px;
    }
  }
  
  .details-section {
    grid-template-columns: 1fr;
  }
  
  .properties-grid {
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  }
  
  .services-grid {
    grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  }
}

.my-custom-class {
  width: 55px;
  height: 55px;
  transform: scale(0.5);
  margin-top: 0 !important;
}

.swal2-title {
  display: inline-block;
  vertical-align: middle;
  line-height: normal;
  padding-top: 0 !important;
  padding-right: 15px !important;
}

.swal2-popup {
  display: flex !important;
  padding-bottom: 0 !important;
  width: 25em;
  align-items: center;
  height: 55px;
  font-size: 12px;
}

.my-gallery {
  display: flex;
  justify-content: center;
}

.gallery-thumbnail img {
  width: 300px;
  height: 300px;
  object-fit: cover;
}

.pswp__zoom-wrap {
  position: relative;
  height: 100%;
}

.pswp__zoom-wrap::after {
  content: '';
  position: absolute;
  top: -60px;
  left: -60%;
  right: 0;
  bottom: 0;
  background-image: url('../../assets/logo.png');
  background-repeat: no-repeat;
  background-position: center;
  opacity: 0.5;
  pointer-events: none;
}

.iconssocials {
  background: rgb(246, 199, 18);
  border-radius: 50%;
  width: 45px;
  height: 45px;
  display: grid;
  text-align: center;
  place-items: center;
  text-decoration: none;
  margin-bottom: 5px;
}

.watermarked {
  position: relative;
  width: max-content;
}

.watermarked::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: url('../../assets/logo.png');
  background-repeat: no-repeat;
  background-position: center;
  opacity: 0.5;
  pointer-events: none;
}
</style>